export default {"src":"/_next/static/media/code-snippet.4d648ad8.svg","height":534,"width":632,"blurWidth":0,"blurHeight":0};